// Стили для App компонента
export const appStyles = {
  container: {
    mt: 4,
    mb: 4,
  },
  title: {
    textAlign: 'center',
    mb: 2,
  },
  subtitle: {
    textAlign: 'center',
    mb: 4,
    color: 'text.secondary',
  },
  featureTableContainer: {
    mt: 4,
  },
  appBarTitle: {
    flexGrow: 1,
  },
} as const;

// Стили для PromptInput компонента
export const promptInputStyles = {
  paper: {
    p: 3,
    mb: 3,
  },
  title: {
    mb: 2,
  },
  tokenField: {
    mb: 2,
  },
  requirementsField: {
    mb: 2,
  },
  errorAlert: {
    mb: 2,
  },
  buttonContainer: {
    display: 'flex',
    gap: 2,
  },
  submitButton: {
    minWidth: 120,
  },
} as const;

// Стили для FeatureTable компонента
export const featureTableStyles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2,
  },
  title: {
    mb: 0,
  },
  copyButton: {
    minWidth: 200,
  },
  tablePaper: {
    elevation: 2,
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
    },
  },
  firstRow: {
    backgroundColor: 'rgba(25, 118, 210, 0.04)',
  },
  groupCell: {
    fontWeight: 'bold',
    color: 'primary.main',
  },
  featureNumberCell: {
    fontWeight: 'bold',
  },
  featureNameCell: {
    fontWeight: 'bold',
  },
  descriptionCell: {
    maxWidth: 400,
  },
  restrictionsCell: {
    maxWidth: 300,
    fontSize: '0.875rem',
  },
  footerContainer: {
    mt: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  footerText: {
    color: 'text.secondary',
  },
  tableRowCombined: (index: number) => ({
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
    },
    ...(index === 0 ? { backgroundColor: 'rgba(25, 118, 210, 0.04)' } : {}),
  }),
} as const;

// Стили для FeatureRefinementDialog компонента
export const featureRefinementDialogStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      width: '100%',
      maxWidth: {
        xs: '95vw', // Мобильные устройства
        sm: '600px', // Планшеты
        md: '800px', // Десктопы
        lg: '1000px', // Большие экраны
      },
      margin: {
        xs: '16px', // Отступы для мобильных
        sm: '32px', // Отступы для планшетов и больше
      },
      maxHeight: {
        xs: '90vh', // Мобильные устройства
        sm: '85vh', // Планшеты и больше
      },
    },
    '& .MuiDialog-container': {
      alignItems: 'flex-start',
      paddingTop: {
        xs: '5vh', // Мобильные устройства
        sm: '7.5vh', // Планшеты и больше
      },
    },
    '& .MuiDialogContent-root': {
      padding: {
        xs: 2, // Мобильные устройства
        sm: 3, // Планшеты и больше
      },
    },
    '& .MuiDialogActions-root': {
      padding: {
        xs: 2, // Мобильные устройства
        sm: 3, // Планшеты и больше
      },
      flexDirection: {
        xs: 'column', // Мобильные устройства - кнопки вертикально
        sm: 'row', // Планшеты и больше - кнопки горизонтально
      },
      gap: {
        xs: 1, // Мобильные устройства
        sm: 2, // Планшеты и больше
      },
    },
  },
  title: {
    // Стили для заголовка диалога
  },
  currentDescriptionContainer: {
    mb: 3,
  },
  currentDescriptionLabel: {
    color: 'text.secondary',
    mb: 1,
  },
  currentDescriptionBox: {
    p: {
      xs: 1.5, // Мобильные устройства
      sm: 2, // Планшеты и больше
    },
    bgcolor: 'grey.50',
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'grey.300',
    fontSize: {
      xs: '0.875rem', // Мобильные устройства
      sm: '1rem', // Планшеты и больше
    },
  },
  divider: {
    my: 2,
  },
  refinementContainer: {
    mb: 3,
  },
  refinementLabel: {
    color: 'text.secondary',
    mb: 1,
  },
  errorAlert: {
    mb: 2,
  },
  newDescriptionContainer: {
    mb: 2,
  },
  newDescriptionLabel: {
    color: 'text.secondary',
    mb: 1,
  },
  newDescriptionBox: {
    p: {
      xs: 1.5, // Мобильные устройства
      sm: 2, // Планшеты и больше
    },
    bgcolor: 'success.50',
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'success.300',
    fontSize: {
      xs: '0.875rem', // Мобильные устройства
      sm: '1rem', // Планшеты и больше
    },
  },
} as const;

// Стили для загрузки
export const loadingStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
} as const;

// Стили для пустого состояния
export const emptyStateStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
  text: {
    color: 'text.secondary',
  },
} as const;

// Типы для стилей
export type AppStyles = typeof appStyles;
export type PromptInputStyles = typeof promptInputStyles;
export type FeatureTableStyles = typeof featureTableStyles;
export type FeatureRefinementDialogStyles = typeof featureRefinementDialogStyles;
